<template>
    <!-- cart table template -->
    <p style="text-align:center;" v-show="Cart.CartItems == null || Cart.CartItems.length == 0">{{getInterfaceText('shop_cart_empty')}}</p>
    <p class="sr-only">{{getInterfaceText('shoppingcart')}}</p>
    <!-- SK 07-05-2024 convert table to divs -->
    <div id="cart" v-show="Cart.CartItems != null && Cart.CartItems.length > 0">
        <!-- head -->
        <div id="cart-head">
            <div class="product" scope="col">{{getInterfaceText('shop_product')}}</div>
            <div class="hidden-xs"></div>
            <div class="price hidden-xs" scope="col">{{getInterfaceText('shop_price')}}</div>
            <div class="quantity" scope="col"><span class="full-label">{{getInterfaceText('shop_quantity')}}</span><span class="short-label">{{getInterfaceText('shop_qty')}}</span></div>
            <div class="total" scope="col">{{getInterfaceText('shop_total')}}</div>
            <div v-if="editMode" class="action" scope="col">&nbsp;</div>
        </div>
         
        <ul id="cart-rows">
            <li v-for="item in Cart.CartItems" role="group" aria-label="item" :id="'cartItem-'+ item.Product.Partnumber.Code" :key="item.Id" :class="[(item.SupplementaryToCartItemId != null ? 'suppplementaryItem' : item.ParentId > 0 ? 'bundleItem' : ''), 'cartItem clearfix', { outOfStock: isCartItemOutOfStock(item) }]">

                <div class="image-and-text">
                    <div scope="row" class="product-image" nowrap="nowrap">

                        <div class="image">
                            <a :href="item.Product.UrlLabel" rel="nofollow" class="cart-item-image-link">
                                <img v-if="item.IsGlobalCatalogue"
                                     :alt="item.Product.Name"
                                     class="main-navigation-shopping-cart-item_image__YMPfS"
                                     height="120"
                                     width="120"
                                     :srcset="`${item.Product.ImageMedium} 1x, ${item.Product.ImageMediumRetina} 2x`"
                                     :src="item.Product.ImageMedium" />

                                <img v-if="item.IsGlobalCatalogue == false" :alt="item.Product.Name" :src="item.Product.Image + '?quality=80&amp;width=128&amp;height=128&amp;mode=pad&amp;bgcolor=white&amp;anchor=middlecenter'">
                            </a>
                        </div>

                    </div>

                    <!-- COL 2-->
                    <div class="product-specs">
                        
                        <span v-if="item.ParentId > 0" class="bundleBadge">Bundle</span>
                        
                        <h3 class="name">
                            <a :href="item.Product.UrlLabel" rel="nofollow" tabindex="-1">{{item.Product.Name}}</a><br />
                        </h3>

                        <!-- color -->
                        <div class="color-and-size">
                            <span class="color" v-if="item.Product.Partnumber.Color != null && item.Product.Partnumber.Color != ''">{{item.Product.Partnumber.Color}}</span>
                            <span class="divider" v-if="item.Product.Partnumber.Color != null && item.Product.Partnumber.Color != '' && item.Product.Partnumber.Size != null">|</span>
                            <span class="size" v-if="item.Product.Partnumber.Size != null">{{item.Product.Partnumber.Size}}</span>
                        </div>

                        <div class="usage" v-if="item.Product.Partnumber.Usage != null">{{item.Product.Partnumber.Usage}}</div>

                        <TypographyDiscoverMode v-if="showCartLineItemNotice(item)"
                                                tag="p"
                                                tag-style="bodySmall"
                                                class="lineItemNotice"
                                                :class="{ lineItemNoticeOutOfStock: isCartItemOutOfStock(item) }">
                            <template v-if="isCartItemOutOfStock(item)">
                                {{ getInterfaceText('shop_item_outofstock') }}
                            </template>
                            <span v-else v-html="getInterfaceText('shop_iscloseoutsale_message')"></span>
                        </TypographyDiscoverMode>

                        <div class="quantity-stepper-and-price">

                            <div class="quantity-stepper">
                                <button v-if="editMode"
                                        type="button"
                                        class="stepper-button"
                                        :class="[cartItemDecrementIsRemoveOnly(item) ? 'remove-item' : 'decrease-quantity', { outOfStockDecrement: isCartItemOutOfStock(item) }]"
                                        v-on:click="handleDecreaseOrRemove(item)"
                                        :aria-label="cartItemDecrementIsRemoveOnly(item) ? getInterfaceText('shop_removethisitem') : getInterfaceText('shop_decreasequantity')">

                                    <svg v-if="!cartItemDecrementIsRemoveOnly(item)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true" preserveAspectRatio="xMidYMid meet" role="presentation">
                                        <path fill="#000" fill-rule="evenodd" d="M20 13H4v-2h16z" clip-rule="evenodd"></path>
                                    </svg>

                                    <svg v-else
                                         width="16"
                                         height="20"
                                         viewBox="0 0 16 20"
                                         xmlns="http://www.w3.org/2000/svg"
                                         fill="currentColor">
                                        <path d="M9.28571 1.42871H16L11.857 4H4.14314V17H11.857V6H14.4283V17C14.4282 18.4201 13.2771 19.5713 11.857 19.5713H4.14314C2.72302 19.5713 1.57192 18.4201 1.57185 17V4H0V1.42871H6.71442V0H9.28572V1.42871Z" />
                                        <path d="M9.28572 15.5713H6.71443V6H9.28572V15.5713Z" />
                                    </svg>
                                </button>

                                <span class="quantity">{{ item.Quantity }}</span>

                                <button type="button"
                                        class="stepper-button increase-quantity"
                                        v-on:click="increaseCartItemQuantity(item)"
                                        :aria-label="getInterfaceText('shop_increasequantity')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true"  preserveAspectRatio="xMidYMid meet" role="presentation">
                                        <path fill="currentColor" fill-rule="evenodd" d="M20 13H4v-2h16z" clip-rule="evenodd"></path>
                                        <path fill="currentColor" fill-rule="evenodd" d="M11 20V4h2v16z" clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>

                            <!-- price / total -->
                            <div class="price">
                                <span class="sr-only">{{getInterfaceText('shop_price')}} {{item.TotalToFormat}}</span>
                                <span class="sr-only" v-if="item.TotalOriginalPriceToFormat && item.TotalOriginalPriceToFormat.length > 0">{{getInterfaceText('shop_price_original')}} {{item.TotalOriginalPriceToFormat}}</span>
                                <span v-if="Cart.EnableLowest30DaysPriceMode == false" class="cartItem-total oldprice">{{item.TotalOriginalPriceToFormat}}</span>
                                <span v-if="Cart.EnableLowest30DaysPriceMode && item.Product.PriceScenario == 1" class="cartItem-total oldprice omnibus-mode">{{item.TotalLowest30PriceToFormat }} </span>
                                <div class="cartItem-total"
                                     :class="{ 'newprice' : (Cart.EnableLowest30DaysPriceMode && item.Product.PriceScenario == 1) || (item.TotalOriginalPriceToFormat && item.TotalOriginalPriceToFormat.length > 0), 'omnibus-mode': Cart.EnableLowest30DaysPriceMode && item.Product.PriceScenario == 1  }">
                                    {{item.TotalToFormat}}
                                </div>
                            </div>

                        </div> 

                    </div>
                </div>

            </li>
        </ul>

    </div>
   

</template>
<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    import TypographyDiscoverMode from './TypographyDiscoverMode.vue';

    export default {
        name: 'CartTableDiscoverMode',
        components: {
            TypographyDiscoverMode,
        },
        mixins: [cartMixin, generalMixin],
        props: ['editMode', 'summaryMode'],
        template: '#cart-table-template',
        data: function () {
            return {
                ProductPriceExcludedTax: false,
                /*ShowGiftcardOrCouponPanel: false,*/
                ShowTaxInclusiveTag: false
            }
        },
        methods: {
            isCartItemOutOfStock(item) {
                if (!item || !item.Stock) return false;
                var c = item.Stock.Code;
                return c === 0 || c === '0' || c === 'nostock';
            },
            showCartLineItemNotice(item) {
                return this.isCartItemOutOfStock(item) || (item.Product && item.Product.IsCloseOutSale && item.Product.IsSale);
            },
            cartItemDecrementIsRemoveOnly(item) {
                return item && (item.IsOneSkuPerProductBundleChild === true || item.Quantity <= 1);
            },
            handleDecreaseOrRemove(item) {
                if (this.cartItemDecrementIsRemoveOnly(item)) {
                    this.removeCartItem(item);
                    return;
                }

                this.decreaseCartItemQuantity(item);
            }
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
